import { FC } from "react";
import { useTranslation } from "react-i18next";

export const HubStationTemplateNoHub: FC = () => {
  const { t } = useTranslation();

  return <span className="no-hub-message">{t("hub.noHubAvailable")}</span>;
};
